import { render } from "./IncapacityWork.vue?vue&type=template&id=4caaa122"
import script from "./IncapacityWork.vue?vue&type=script&lang=js"
export * from "./IncapacityWork.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__